import React, { useEffect, useState, useMemo , useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setClientBranchActions,
  setClientBranchDeleteActions,
  setGeoLoactionStateAction,
  setClientBranchSearchAction,
  setZoneActions,
  setRegionActions,
  getClientEditActions,
  getClientbranchEditView,
  setDetailView,
  getSideBarfilesActions,
  getClientBranchIds,
  SetTHeNavigateList,
  setTheBranchObject, ///--site---transfer
  setClientBranchSearchEmpty,
  Branch_EDIT_CLIENT_DETAILS, ///--for---client---details
  settheAttendanceReportState,
  setThaAttendanceReportRegion,
  setThaAttendanceReportZone,
  setTablePositionPersist

} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import Delete from "../../AppComponent/Popup/Delete";
import "../../../StyleSheet/MainComponent/ClientBranches/ClientBranches.scss";
import Select from "react-select";
import { el, tr } from "date-fns/locale";
import clientimg from "../../../Assets/AppComponent/icons/Client/Vector.svg";
import Regionicons from "../../../Assets/AppComponent/icons/Locationicons/Layer_1 .png";
import { NavLink } from "react-router-dom";
import { Navigate, useNavigate } from "react-router-dom";
import CalenderPopup from "./CalenderPopup";
import _ from "lodash";
import AttedanceExport from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-08.svg";
import useDebouncedEffect from 'use-debounced-effect';

const Report = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
    const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist
  );
  const dispatch = useDispatch();
const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.BranchAttendanceReportPages?.page == undefined
      ? 1
      : TablePositionPersist.BranchAttendanceReportPages.page
  );
    const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [Datas, setDatas] = useState([]);
const [search, setsearch] = useState(
    TablePositionPersist?.BranchAttendanceReportPages?.search == undefined || 
    TablePositionPersist?.BranchAttendanceReportPages?.search == ""
      ? ""
      : TablePositionPersist.BranchAttendanceReportPages.search
  );
    const state = useSelector((state) => state);
  const [CreateBranch, setCreateBranch] = useState(false);
  const [BranchesEdits, setBranchesPopup] = useState(false);
  const [EditId, setEdit] = useState();
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [State, setState] = useState([]);
  const [multiselect, setMuliselect] = useState([
    //  { value: "", label: "All" }
    // state.ClientBranchIDs.StateName,
    state.StateManagementOverallCall.AttendanceReportState

  ]);
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.RegionName,
     state.StateManagementOverallCall.AttendanceReportRegion
  ]);
  const [multiselect3, setMuliselect3] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.ZoneName,
    state.StateManagementOverallCall.AttendanceReportZone

  ]);
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setData] = useState({
    // zone: state.ClientBranchIDs.ZoneName.value,
    // state: state.ClientBranchIDs.StateName.value,
    // region: state.ClientBranchIDs.RegionName.value,

    zone: state.StateManagementOverallCall.AttendanceReportZone.value,
    state: state.StateManagementOverallCall.AttendanceReportState.value,
    region: state.StateManagementOverallCall.AttendanceReportRegion.value,


  });
  const UserObjectData = useSelector((state) => state.users.UserData);

  const [BranchSearch, setbranchSearch] = useState([]);
  const [Rendering, setRendering] = useState(true);
  const [details, setDetails] = useState(false);
  const [MakeCreate, setCreateBar] = useState(true);
  const [counts, setcounts] = useState(1);
  const [errorFilter, seterrorFilter] = useState({
    state: "",
    region: "",
    zone: "",
  });
  const [EditID, setEditId] = useState();
  const [EditPopupCall, setEditPopup] = useState(false);

  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

   ///-----State----Input Changes
   const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,

    });

};

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
///----Zone---Name
const handleInputZone = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        zoneSearch: Val,
    });
};

useDebouncedEffect(
  () => {
      if (setSearchDebounance) {
          setSearched({
              ...SearchedVal,
              stateSearch: SearchDebounance.stateSearch,
              regionSearch: SearchDebounance.regionSearch,
              zoneSearch: SearchDebounance.zoneSearch,
          });

      }
  },
  500,
  [SearchDebounance]
);


  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1)
    debouncedSearch(e);
 
  }

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setcounts(2);
setsearch(e)
      }, 500),
    []
  );

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [
    debouncedSearch,
  ]);


  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    ///   console.log(arg, "args");
    setdtPageindex(arg);
  };
  //---Create
  const CreateBranchFunction = () => {
    // window.location.href = "/clientcreate";
    Navigate("/clientcreate");
    dispatch(getClientbranchEditView(""));
    //dispatch(setDetailView(false))
  };
  //--Edit---
  const ClientEditFunctions = (id) => {
    setBranchesPopup(!BranchesEdits);
    setEdit(id);
    dispatch(getClientEditActions(true));
    dispatch(getClientbranchEditView(id));
    dispatch(setDetailView(false));
    // window.location.href = "/clientcreate"
  };
  const Navigate = useNavigate();

  ////---View
  const ViewFunctions = (id) => {
    setBranchesPopup(true);
    console.log(id, "sdgsdgsgts");
    dispatch(getClientbranchEditView(id.id));
    ///---onboard---employeee----list
    dispatch(setTheBranchObject({ value: id.id, label: id.client_name })); ///--for---site---transfer

    //setEdit(row.row.original.id);
    dispatch(getClientEditActions(true));
    dispatch(setDetailView(true));
    setDetails(true);
    // window.location.href = "/clientDetails";
    // Navigate("/clientDetails");
    dispatch(getClientBranchIds(id.client_id.id));
    console.log("isdasdasdashds", id.client_id.id, id);
    dispatch(getSideBarfilesActions("Attendance  Report"));

    if (
      id.client_id.id == state.ClientBranchIDs.ClientBranchID &&
      id.id == state.ClientBranchIDs.clientBranchEditView 
      &&
      state.SideBarFiles.SideBarFile == "Attendance  Report"
    ) {
      //console.log(id.client_id.id, "clientBranch IDS");
      Navigate("/profile");
    }
    // dispatch(SetTHeNavigateList("/clientbranch"));
    // dispatch(SetTHeNavigateList(["/ClientDetails"]));
  };


     const truncate = (value, length = 10) => {
  if (!value) return "";
  return value.length > length ? value.substring(0, length) + "..." : value;
};

  const columns = [
    // {
    //   Header: "Client Branch",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         <div
    //           style={{ cursor: "pointer", padding: "12px" }}
    //           //onClick={(e) => {
    //           // ViewFunctions(row.row.original.id);
    //           // }}
    //         >
    //           <div className="IconsDesign">
            
    //             <span>{row.row.original.client_name}</span>
    //           </div>
    //         </div>
    //       </>
    //     );
    //   },
    // },
{
  Header: "Client Branch",
  accessor: "",
  Cell: (row) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const client = row?.row?.original;
    const branchCode = client?.branch_code ?? "";
    const clientName = client?.client_name ?? "";

    // Full label for tooltip
    const fullLabel = branchCode
      ? `${branchCode} - ${clientName}`
      : clientName;

    // Short display (truncate client name only)
    const shortName =
      clientName.length > 12 ? `${clientName.slice(0, 12)}...` : clientName;

    const shortLabel = branchCode
      ? `${branchCode} - ${shortName}`
      : shortName;

    return (
      <>
        {client && clientName ? (
          <div
            className="UserName"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            style={{ position: "relative" }}
          >
            <span>{shortLabel}</span>

            {showTooltip && (
              <div className="custom-tooltip">{fullLabel}</div>
            )}
          </div>
        ) : (
          <div className="UserName">
            <span>---</span>
          </div>
        )}
      </>
    );
  },
},

  {
  Header: "State",
  accessor: "",
  Cell: ({ row }) => {
    const stateName = row.original.state_id?.state_name ?? "---";
    return <span>{truncate(stateName, 10)}</span>;
  },
},

{
  Header: "Region",
  accessor: "",
  Cell: ({ row }) => {
    const regionName = row.original.region_id?.region_name ?? "---";
    return (
      <div className="IconsDesign">
        <span>{truncate(regionName, 10)}</span>
      </div>
    );
  },
},

         {
      Header: "Zone",
      accessor: "",
       Cell: (row) => {
        return (
          <>
            {row.row.original.zone_id != null ? (
              <span>{truncate(row.row.original.zone_id.zone_name, 12)}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <p
              data-tooltip-id="my-tooltip"
              data-tooltip-content={`${formattedTime}`}
            >
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </p>
          </>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                onClick={(e) => {
                  e.stopPropagation();
                  setEditId(row.row.original.id);
                  setEditPopup(true);
                }}
                component="span"
              >
                {/* <span>
                  <i
                    class="fa-solid fa-file-arrow-down"
                    style={{ fontSize: "13px", paddingRight: "3px" }}
                  ></i>
                  Export
                </span> */}

                <span className="OuterActionSpan">
                  {/* <i
                    class="fa-solid fa-file-arrow-down"
                    // style={{
                    //   fontSize: "15px",
                    //   paddingRight: "3px",
                    //   paddingBottom: "3px",
                    // }}
                    style={{ fontSize: "13px", paddingRight: "3px" }}
                  ></i> */}
                  <span  className="AttendanceExportImage">
                    <img src={AttedanceExport}/>
                  </span>

                  <span className="ActionsList"> Export </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ];
  const HandleSubmits = () => {
    if (DeleteID != undefined) {
      const payload = {
        DeleteID: DeleteID,
        currentPage: dtpageindex,
      };
      dispatch(setClientBranchDeleteActions(payload, setDeletePopup(false)));
    }
  };
  useEffect(() => {

      const payload = {
        search: search,
        // page_size: dtpagesize,
        page_size:20,
        page: dtpageindex,
        data: data,
      };

    //  if (
    //   state.BranchSearchpart.BranchSearch.length == 0 ||
    //   TablePositionPersist?.BranchAttendanceReportPages?.page != dtpageindex ||
    //   TablePositionPersist?.BranchAttendanceReportPages?.search != search ||
    //   TablePositionPersist?.BranchAttendanceReportPages?.data?.state != data.state ||
    //   TablePositionPersist?.BranchAttendanceReportPages?.data?.region != data.region ||
    //   TablePositionPersist?.BranchAttendanceReportPages?.data?.zone != data.zone
    // ) {

      dispatch(setClientBranchSearchAction(payload));
      dispatch(
        setTablePositionPersist({
          data: payload,
          pageName: "BranchAttendanceReportPages",
        })
      );
    // }
     currentRef.current.scrollTop = sessionStorage.getItem(
      "AttendanceReportBranchscroll"
    );
      setbranchSearch(state.BranchSearchpart.BranchSearch);

  }, [data.zone, data.state, data.region , dtpageindex, search]);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
    setState(state.GeoState.State);
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);

  const handleSelectChange = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(settheAttendanceReportState(selectedVal))
      dispatch(setThaAttendanceReportRegion({ value: "", label: "ALL" }))

      dispatch(setThaAttendanceReportZone({ value: "", label: "ALL" }))

      console.log(selectedVal, "asfad");
      setData({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
      setcounts(2);
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(settheAttendanceReportState({ value: "", label: "ALL" }))
      dispatch(setThaAttendanceReportRegion({ value: "", label: "ALL" }))

      dispatch(setThaAttendanceReportZone({ value: "", label: "ALL" }))

      setData({
        ...data,
        state: "",
        region: "",
        zone: "",
      });
      const payload = {
        search: "",
        page_size: dtpagesize,
        page: dtpageindex,
      };
      // dispatch(setClientBranchSearchEmpty(""));
      dispatch(setClientBranchActions(payload));
      // console.log(
      // selectedVal,
      // "yes its Null",
      // state.ClientBranch.ClientBranchess,
      // state.BranchSearchpart.BranchSearch
      // );
      setcounts(1);
    }
  };
  //
  // useEffect(() => {
  // console.log(state.ClientBranch.ClientBranchess, "statesxasfsd");
  // if (data.state == null || data.state == undefined) {
  // console.log("yfusdyufyu");
  // }
  // }, [data.state]);
  //

  useEffect(() => {
    const Datas = [];

    setState(state.GeoState.State.state_name);
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" })
      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];

    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setData({
        ...data,
        region: selectedVal.value,
      });
      setcounts(2);

      dispatch(setThaAttendanceReportRegion(selectedVal))

      dispatch(setThaAttendanceReportZone({ value: "", label: "ALL" }))
      setMuliselect3({ value: "search", label: "Search" });


    }
    if (selectedVal == null && data.state == null && data.zone == null) {
      setData({
        ...data,
        region: "",
      });
      const payload = {
        search: "",
        page_size: dtpagesize,
        page: dtpageindex,
      };
      // dispatch(setClientBranchSearchEmpty(""));
      dispatch(setClientBranchActions(payload));
      // console.log(
      //   selectedVal,
      //   "yes its Null",
      //   state.ClientBranch.ClientBranchess,
      //   state.BranchSearchpart.BranchSearch
      // );
      setcounts(1);
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        region: "",
        zone: "",
      });


      dispatch(setThaAttendanceReportRegion({ value: "", label: "ALL" }))

      dispatch(setThaAttendanceReportZone({ value: "", label: "ALL" }))



    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    setdtPageindex(1);

    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...data,
        zone: selectedVal.value,
      });
      setcounts(2);


      dispatch(setThaAttendanceReportZone(selectedVal))




    }
    if (selectedVal == null && data.region == null && data.state == null) {
      setData({
        ...data,
        zone: "",
      });
      const payload = {
        search: "",
        page_size: dtpagesize,
        page: dtpageindex,
      };
      ///  dispatch(setClientBranchSearchEmpty(""));
      dispatch(setClientBranchActions(payload));
      console.log(
        selectedVal,
        "yes its Null",
        state.ClientBranch.ClientBranchess,
        state.BranchSearchpart.BranchSearch
      );
      setcounts(1);
    }

    if (selectedVal == null) {
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        zone: "",
      });


      dispatch(setThaAttendanceReportZone({ value: "", label: "ALL" }))




    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];

    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};
 const currentRef = useRef();
  const scrollPosition = (e) => {
    const val = currentRef.current.scrollTop;


    sessionStorage.setItem("AttendanceReportBranchscroll", val);
  };
  return (
    <>
      <div 
              onScroll={scrollPosition}
        ref={currentRef}
      className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Attendance Report</h3>
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               

            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              value={multiselect}
            />
          </div>

          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                seterrorFilter({ ...errorFilter, region: "" });

                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
             isClearable={
  multiselect1
    ? Array.isArray(multiselect1)
      ? multiselect1.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect1.label === "ALL" || multiselect1.label === "All"
      ? false
      : true
    : true
}              value={multiselect1}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              onInputChange={handleInputRegion}
            />
            <p>{errorFilter.region}</p>
          </div>

          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              options={nameList4}
                isClearable={
  multiselect3
    ? Array.isArray(multiselect3)
      ? multiselect3.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect3.label === "ALL" || multiselect3.label === "All"
      ? false
      : true
    : true
}              value={multiselect3}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}

              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>

        </div>

        {/* {Datas != undefined ? ( */}
          <div style={{ padding: "  0px 40px", marginTop: "-10px " }}>
            <ReactTable
              data={

                state.BranchSearchpart.BranchSearch
              }
              columns={columns}
              currentPage={currentPage}
              totalItems={
                state.BranchSearchpart.Total_count
              }
              pagesize={pagesize}
              dtpagesize={pageSize}
              pageindex={pageindex}
              datacount={
                state.BranchSearchpart.Total_count
              }
              dtpageindex={dtpageindex}
              onChange={tochange}
              MakeCreate={MakeCreate}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}

              ViewParts={(e) => {
                ViewFunctions(e);
              }}

              Filter={true}
              NoFilter ={true}
                       searchVal={TablePositionPersist?.BranchAttendanceReportPages?.search == "" || TablePositionPersist?.BranchAttendanceReportPages?.search ==undefined? "":TablePositionPersist.BranchAttendanceReportPages.search}
              search_key={true}
            />
          </div>
        {/* ) : null} */}
      </div>
      {EditID != undefined && currentPage != undefined && EditPopupCall ? (
        <CalenderPopup
          show={EditPopupCall}
          setShow={setEditPopup}
          EditID={EditID}
          currentPage={dtpageindex}
          counts={1}
        />
      ) : null}
    </>
  );
};

export default Report;
